/**
 * Haley Product Comparison Table
 * Mobile-optimized with:
 * - Tab switching
 * - Swipe gestures
 * - Reveal animations
 * - Firmness bar animations
 */
(function () {
  'use strict';

  var root = document.querySelector('.haley-product-compare');
  if (!root) return;

  var tabs = root.querySelectorAll('.pct-tab-btn');
  var cards = root.querySelectorAll('.pct-mobile-card');
  var cardsContainer = root.querySelector('.pct-mobile-cards');
  var products = ['hybrid', 'purify', 'airpro'];
  var currentIndex = 0;

  // ─── Tab Switching ───────────────────────────────────────────
  function showCard(productId, direction) {
    var newIndex = products.indexOf(productId);
    if (newIndex === -1) return;

    // Reset all tabs
    tabs.forEach(function (tab) {
      tab.className = 'pct-tab-btn';
      tab.setAttribute('aria-selected', 'false');
      tab.tabIndex = -1;
    });

    // Hide all cards
    cards.forEach(function (card) {
      card.classList.remove('visible', 'swipe-left', 'swipe-right');
    });

    // Show selected card with animation
    var targetCard = document.getElementById('pct-card-' + productId);
    if (targetCard) {
      // Add swipe animation class based on direction
      if (direction === 'left') {
        targetCard.classList.add('swipe-left');
      } else if (direction === 'right') {
        targetCard.classList.add('swipe-right');
      }
      targetCard.classList.add('visible');
    }

    // Activate selected tab
    if (tabs[newIndex]) {
      tabs[newIndex].classList.add('active-' + productId);
      tabs[newIndex].setAttribute('aria-selected', 'true');
      tabs[newIndex].tabIndex = 0;
    }

    currentIndex = newIndex;
  }

  // Attach click handlers to tabs
  tabs.forEach(function (tab, index) {
    tab.id = 'tab-' + products[index];
    tab.tabIndex = index === 0 ? 0 : -1;
    tab.addEventListener('click', function () {
      var direction = index > currentIndex ? 'left' : 'right';
      showCard(products[index], direction);
    });
    tab.addEventListener('keydown', function (event) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      var nextIndex = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (currentIndex + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      showCard(products[nextIndex]);
      tabs[nextIndex].focus();
    });
  });

  // Initialize first tab as active
  if (tabs.length > 0) {
    tabs[0].classList.add('active-hybrid');
  }

  // ─── Swipe Gestures ──────────────────────────────────────────
  if (cardsContainer && 'ontouchstart' in window) {
    var touchStartX = 0;
    var touchStartY = 0;
    var touchEndX = 0;
    var touchEndY = 0;
    var minSwipeDistance = 50;
    var maxVerticalDistance = 100;

    cardsContainer.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    }, { passive: true });

    cardsContainer.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      touchEndY = e.changedTouches[0].screenY;
      handleSwipe();
    }, { passive: true });

    function handleSwipe() {
      var deltaX = touchEndX - touchStartX;
      var deltaY = Math.abs(touchEndY - touchStartY);

      // Only trigger if horizontal swipe is dominant
      if (Math.abs(deltaX) > minSwipeDistance && deltaY < maxVerticalDistance) {
        if (deltaX < 0) {
          // Swipe left - next product
          goToNext();
        } else {
          // Swipe right - previous product
          goToPrev();
        }
      }
    }

    function goToNext() {
      var nextIndex = (currentIndex + 1) % products.length;
      showCard(products[nextIndex], 'left');
    }

    function goToPrev() {
      var prevIndex = (currentIndex - 1 + products.length) % products.length;
      showCard(products[prevIndex], 'right');
    }
  }

  // ─── Firmness Bar Animation ──────────────────────────────────
  var firmnessBars = root.querySelectorAll('[data-pct-firmness]');

  if (firmnessBars.length && 'IntersectionObserver' in window) {
    var barObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var pct = entry.target.getAttribute('data-pct-firmness');
            entry.target.style.width = pct + '%';
            barObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    firmnessBars.forEach(function (bar) {
      bar.style.width = '0%';
      barObserver.observe(bar);
    });
  }

  // ─── Dot Indicators (optional) ───────────────────────────────
  function createDotIndicators() {
    var existingDots = root.querySelector('.pct-dots');
    if (existingDots) return;

    var dotsContainer = document.createElement('div');
    dotsContainer.className = 'pct-dots';
    dotsContainer.setAttribute('aria-hidden', 'true');

    products.forEach(function (product, index) {
      var dot = document.createElement('span');
      dot.className = 'pct-dot' + (index === 0 ? ' active' : '');
      dot.setAttribute('data-product', product);
      dotsContainer.appendChild(dot);
    });

    // Insert after tab bar
    var tabBar = root.querySelector('.pct-tab-bar');
    if (tabBar && tabBar.parentNode) {
      tabBar.parentNode.insertBefore(dotsContainer, tabBar.nextSibling);
    }
  }

  // Update dot indicators when card changes
  function updateDots() {
    var dots = root.querySelectorAll('.pct-dot');
    dots.forEach(function (dot, index) {
      dot.classList.toggle('active', index === currentIndex);
    });
  }

  // Add dot styles dynamically
  function addDotStyles() {
    if (document.getElementById('pct-dot-styles')) return;

    var style = document.createElement('style');
    style.id = 'pct-dot-styles';
    style.textContent = '\
      .pct-dots {\
        display: flex;\
        justify-content: center;\
        gap: 8px;\
        padding: 0 0 12px;\
      }\
      .pct-dot {\
        width: 8px;\
        height: 8px;\
        border-radius: 50%;\
        background: rgba(52, 55, 58, 0.15);\
        transition: all 0.2s ease;\
      }\
      .pct-dot.active {\
        width: 24px;\
        border-radius: 4px;\
        background: var(--pct-text);\
      }\
      @media (min-width: 768px) {\
        .pct-dots { display: none; }\
      }\
    ';
    document.head.appendChild(style);
  }

  // Initialize dots
  addDotStyles();
  createDotIndicators();

  // Override showCard to update dots
  var originalShowCard = showCard;
  showCard = function (productId, direction) {
    originalShowCard(productId, direction);
    updateDots();
  };

})();
